module.exports = {
  "mode": "compressed",
  "staticDomainPrefix": "//static.hsappstatic.net",
  "bender": {
    "depVersions": {
      "conversations-embed": "static-1.25923",
      "conversations-internal-schema": "static-1.12508",
      "head-dlb": "static-1.4841",
      "hs-test-utils": "static-1.7821",
      "hubspot-url-utils": "static-1.3973",
      "HubStyleTokens": "static-2.11248",
      "I18n": "static-7.1574",
      "jasmine-runner": "static-1.6288",
      "quartz": "static-1.6756",
      "react": "static-7.180",
      "sinon": "static-1.9",
      "StyleGuideUI": "static-3.484",
      "webpack-env": "static-1.54",
      "visitor-ui-component-library": "static-1.5950",
      "enviro": "static-4.405",
      "hs-promise-rejection-tracking": "static-1.5387",
      "PortalIdParser": "static-2.367",
      "raven": "static-3.5725",
      "raven-hubspot": "static-1.6032",
      "bend-plugin-trellis-migration": "static-1.3244",
      "moment": "static-3.26",
      "customer-data-email": "static-1.17694",
      "cv-backend-services": "static-1.1505",
      "hub-http": "static-1.6036",
      "immutable": "static-2.19",
      "immutable-less": "static-1.4470",
      "quartz-config": "static-1.534",
      "quartz-core": "static-1.5975",
      "transmute": "static-2.85",
      "HeadJS": "static-2.713",
      "react-dom": "static-7.85",
      "foundations-components": "static-1.7555",
      "framer-motion": "static-1.67",
      "hs-test-utils-bend-plugin": "static-1.2932",
      "msw": "static-1.39",
      "react-redux": "static-7.67",
      "redux": "static-4.16",
      "testing-library": "static-1.147",
      "foundations-theming": "static-1.4227",
      "i18n-data": "static-1.217",
      "metrics-js": "static-1.9453",
      "moment-timezone": "static-5.78",
      "react-utils": "static-2.5188",
      "jasmine": "static-4.4142",
      "csstype": "static-1.50",
      "hoist-non-react-statics": "static-3.9",
      "PatternValidationJS": "static-1.437",
      "react-aria": "static-1.61",
      "styled-components": "static-2.85",
      "UIComponents": "static-3.8195",
      "visitor-ui-component-library-icons": "static-1.5761",
      "bender-build-tools": "static-1.2968",
      "apollo-dlb": "static-3.80",
      "apollo-link-hub-http": "static-2.4466",
      "apollo-stack-hubspot": "static-3.81",
      "classnames": "static-2.10",
      "cssUtils": "static-1.736",
      "customer-data-objects": "static-1.7465",
      "customer-data-ui-utilities": "static-1.9639",
      "data-fetching-client": "static-1.9493",
      "FileManagerCore": "static-1.38438",
      "FileManagerLib": "static-1.38579",
      "foundations-assets": "static-1.4652",
      "graphql": "static-1.77",
      "hs-promise-utils": "static-1.5409",
      "hubspot-apollo-client": "static-1.4697",
      "icons": "static-2.623",
      "react-immutable-proptypes": "static-2.8",
      "react-immutable-render-mixin": "static-1.9",
      "react-input-autosize": "static-2.17",
      "react-select-plus": "static-1.65",
      "react-virtualized": "static-2.94",
      "rpc-client-utils": "static-1.4450",
      "salesImages": "static-1.521",
      "timezone-utils": "static-2.5060",
      "ui-gdpr-components": "static-1.10163",
      "ts-schema": "static-1.3919",
      "hs-lodash": "static-4.45",
      "immer": "static-1.33",
      "dispatcher": "static-1.132",
      "general-store": "static-6.20",
      "hub-http-janus": "static-1.798",
      "hubspotter-http": "static-1.4493",
      "mobile-manifest-mixins": "static-1.486",
      "module-federation": "static-1.18",
      "quartz-auth": "static-1.431",
      "quartz-head": "static-1.421",
      "quartz-i18n": "static-1.431",
      "quartz-routing": "static-1.186",
      "quartz-test": "static-1.431",
      "quartz-tracking": "static-1.135",
      "quick-fetch": "static-1.3750",
      "react-rhumb": "static-1.16466",
      "ui-fonts": "static-1.510",
      "usage-tracker-container": "static-1.7140",
      "usage-tracker-core": "static-1.7000",
      "bend-plugin-foundations-components": "static-1.3824",
      "floating-ui": "static-1.51",
      "foundations-theming-specialty": "static-1.1943",
      "hs-story-utils": "static-1.9243",
      "tanstack-table": "static-1.50",
      "trellis-assets": "static-1.1254",
      "ui-images": "static-2.1096",
      "bend-plugin-foundations-theming": "static-1.2710",
      "foundations-theming-base": "static-1.3212",
      "stylex": "static-1.27",
      "HubStyle": "static-2.11556",
      "sassPrefix": "static-1.152",
      "inbound-db-properties-service-client": "static-1.3690",
      "property-translator": "static-1.5228",
      "react-dnd-compat": "static-1.4436",
      "fast-json-stable-stringify": "static-1.4",
      "ai-components-ui-library": "static-1.8387",
      "audio-components": "static-1.5634",
      "cropperjs": "static-1.10",
      "file-manager-components": "static-1.22939",
      "FileManagerImages": "static-1.36090",
      "foundations-components-legacy": "static-1.580",
      "immerable": "static-1.3971",
      "redux-toolkit": "static-1.7",
      "reselect": "static-2.16",
      "ui-universal-auth": "static-1.8720",
      "urlinator": "static-1.4348",
      "video-components": "static-1.12615",
      "video-data-lib": "static-1.34270",
      "video-embed": "static-1.35104",
      "redux-thunk": "static-2.43",
      "hubspot-apollo-cache": "static-1.156",
      "hub-http-shared-msw-handlers": "static-1.9509",
      "hubspotter-http-shared-msw-handlers": "static-1.9507",
      "history": "static-4.47",
      "react-router-dom": "static-5.26",
      "react-dnd": "static-5.6",
      "react-dnd-html5-backend": "static-5.6",
      "autolinker": "static-3.11",
      "chatspot-core": "static-1.20388",
      "chirp-fetch": "static-1.1698",
      "ContentUtils": "static-1.67666",
      "copilot-toolkit": "static-1.10572",
      "sanitize": "static-1.4290",
      "sanitize-text": "static-1.7958",
      "content-assistance-lib": "static-1.7471",
      "usage-tracker": "static-1.7150",
      "ui-addon-iframeable": "static-1.8861",
      "video-components-external": "static-1.10612",
      "unified-auth-core-lib": "static-1.515",
      "content-icons-ui": "static-1.2158",
      "social-insights-client-types": "static-1.21398",
      "SharedI18nStrings": "static-1.180",
      "outpost": "static-1.4020",
      "markdown-it": "static-1.6",
      "cms-field-types": "static-1.4622",
      "integrations-lib": "static-1.15461",
      "underscore": "static-1.8",
      "magpie-lib": "static-1.5410",
      "magpie-types": "static-1.4870",
      "simple-logging-lib": "static-1.2866",
      "superstore": "static-1.4586",
      "ui-addon-video-player": "static-1.8512",
      "ui-coaching-tips": "static-1.27981",
      "navigation-messaging": "static-1.6640",
      "content-media-composition-data-lib": "static-1.11513",
      "content-media-compositions": "static-2.15520",
      "idb-keyval": "static-1.39",
      "media-bridge-lib": "static-1.18589",
      "fsm": "static-1.3548",
      "flux-actions": "static-1.310",
      "frontend-preferences-client": "static-1.7740",
      "integrations-error-boundary-lib": "static-1.12876",
      "integrations-tracking-lib": "static-1.5405",
      "laboratory-lib": "static-3.6976",
      "native-integrations-shared-strings": "static-1.7604",
      "redux-observable": "static-1.11",
      "ReduxMessenger": "static-2.10187",
      "rxjs": "static-5.10",
      "ui-addon-i18n": "static-1.10957",
      "ui-shepherd-react": "static-3.9963",
      "reactive-lib": "static-1.541",
      "growth-onboarding-feedback-components": "static-1.6399",
      "hls.js": "static-1.34",
      "js-cookie": "static-1.18",
      "universal-page-editor-lib": "static-1.2816",
      "foundations-components-test-utils": "static-1.5038",
      "react-dlb": "static-1.73",
      "crm-record-cards-service-types": "static-1.3460",
      "framework-data-schema-resolvers": "static-1.6689",
      "location-customization-utils-lib": "static-1.8609",
      "batch-promise": "static-1.1367",
      "conditional-properties-service-client": "static-1.3638",
      "crm-pipelines-api-client-types": "static-1.3979",
      "framework-builder-read-service-client": "static-1.3848",
      "framework-data-schema-quick-fetch": "static-1.6594",
      "inbound-db-meta-service-client": "static-1.3433",
      "multi-currency-client-types": "static-1.3532",
      "persist-promise": "static-1.3524"
    },
    "depPathPrefixes": {
      "conversations-embed": "/conversations-embed/static-1.25923",
      "conversations-internal-schema": "/conversations-internal-schema/static-1.12508",
      "head-dlb": "/head-dlb/static-1.4841",
      "hs-test-utils": "/hs-test-utils/static-1.7821",
      "hubspot-url-utils": "/hubspot-url-utils/static-1.3973",
      "HubStyleTokens": "/HubStyleTokens/static-2.11248",
      "I18n": "/I18n/static-7.1574",
      "jasmine-runner": "/jasmine-runner/static-1.6288",
      "quartz": "/quartz/static-1.6756",
      "react": "/react/static-7.180",
      "sinon": "/sinon/static-1.9",
      "StyleGuideUI": "/StyleGuideUI/static-3.484",
      "webpack-env": "/webpack-env/static-1.54",
      "visitor-ui-component-library": "/visitor-ui-component-library/static-1.5950",
      "enviro": "/enviro/static-4.405",
      "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5387",
      "PortalIdParser": "/PortalIdParser/static-2.367",
      "raven": "/raven/static-3.5725",
      "raven-hubspot": "/raven-hubspot/static-1.6032",
      "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3244",
      "moment": "/moment/static-3.26",
      "customer-data-email": "/customer-data-email/static-1.17694",
      "cv-backend-services": "/cv-backend-services/static-1.1505",
      "hub-http": "/hub-http/static-1.6036",
      "immutable": "/immutable/static-2.19",
      "immutable-less": "/immutable-less/static-1.4470",
      "quartz-config": "/quartz-config/static-1.534",
      "quartz-core": "/quartz-core/static-1.5975",
      "transmute": "/transmute/static-2.85",
      "HeadJS": "/HeadJS/static-2.713",
      "react-dom": "/react-dom/static-7.85",
      "foundations-components": "/foundations-components/static-1.7555",
      "framer-motion": "/framer-motion/static-1.67",
      "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2932",
      "msw": "/msw/static-1.39",
      "react-redux": "/react-redux/static-7.67",
      "redux": "/redux/static-4.16",
      "testing-library": "/testing-library/static-1.147",
      "foundations-theming": "/foundations-theming/static-1.4227",
      "i18n-data": "/i18n-data/static-1.217",
      "metrics-js": "/metrics-js/static-1.9453",
      "moment-timezone": "/moment-timezone/static-5.78",
      "react-utils": "/react-utils/static-2.5188",
      "jasmine": "/jasmine/static-4.4142",
      "csstype": "/csstype/static-1.50",
      "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
      "PatternValidationJS": "/PatternValidationJS/static-1.437",
      "react-aria": "/react-aria/static-1.61",
      "styled-components": "/styled-components/static-2.85",
      "UIComponents": "/UIComponents/static-3.8195",
      "visitor-ui-component-library-icons": "/visitor-ui-component-library-icons/static-1.5761",
      "bender-build-tools": "/bender-build-tools/static-1.2968",
      "apollo-dlb": "/apollo-dlb/static-3.80",
      "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4466",
      "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.81",
      "classnames": "/classnames/static-2.10",
      "cssUtils": "/cssUtils/static-1.736",
      "customer-data-objects": "/customer-data-objects/static-1.7465",
      "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9639",
      "data-fetching-client": "/data-fetching-client/static-1.9493",
      "FileManagerCore": "/FileManagerCore/static-1.38438",
      "FileManagerLib": "/FileManagerLib/static-1.38579",
      "foundations-assets": "/foundations-assets/static-1.4652",
      "graphql": "/graphql/static-1.77",
      "hs-promise-utils": "/hs-promise-utils/static-1.5409",
      "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4697",
      "icons": "/icons/static-2.623",
      "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
      "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
      "react-input-autosize": "/react-input-autosize/static-2.17",
      "react-select-plus": "/react-select-plus/static-1.65",
      "react-virtualized": "/react-virtualized/static-2.94",
      "rpc-client-utils": "/rpc-client-utils/static-1.4450",
      "salesImages": "/salesImages/static-1.521",
      "timezone-utils": "/timezone-utils/static-2.5060",
      "ui-gdpr-components": "/ui-gdpr-components/static-1.10163",
      "ts-schema": "/ts-schema/static-1.3919",
      "hs-lodash": "/hs-lodash/static-4.45",
      "immer": "/immer/static-1.33",
      "dispatcher": "/dispatcher/static-1.132",
      "general-store": "/general-store/static-6.20",
      "hub-http-janus": "/hub-http-janus/static-1.798",
      "hubspotter-http": "/hubspotter-http/static-1.4493",
      "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.486",
      "module-federation": "/module-federation/static-1.18",
      "quartz-auth": "/quartz-auth/static-1.431",
      "quartz-head": "/quartz-head/static-1.421",
      "quartz-i18n": "/quartz-i18n/static-1.431",
      "quartz-routing": "/quartz-routing/static-1.186",
      "quartz-test": "/quartz-test/static-1.431",
      "quartz-tracking": "/quartz-tracking/static-1.135",
      "quick-fetch": "/quick-fetch/static-1.3750",
      "react-rhumb": "/react-rhumb/static-1.16466",
      "ui-fonts": "/ui-fonts/static-1.510",
      "usage-tracker-container": "/usage-tracker-container/static-1.7140",
      "usage-tracker-core": "/usage-tracker-core/static-1.7000",
      "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3824",
      "floating-ui": "/floating-ui/static-1.51",
      "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1943",
      "hs-story-utils": "/hs-story-utils/static-1.9243",
      "tanstack-table": "/tanstack-table/static-1.50",
      "trellis-assets": "/trellis-assets/static-1.1254",
      "ui-images": "/ui-images/static-2.1096",
      "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2710",
      "foundations-theming-base": "/foundations-theming-base/static-1.3212",
      "stylex": "/stylex/static-1.27",
      "HubStyle": "/HubStyle/static-2.11556",
      "sassPrefix": "/sassPrefix/static-1.152",
      "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3690",
      "property-translator": "/property-translator/static-1.5228",
      "react-dnd-compat": "/react-dnd-compat/static-1.4436",
      "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
      "ai-components-ui-library": "/ai-components-ui-library/static-1.8387",
      "audio-components": "/audio-components/static-1.5634",
      "cropperjs": "/cropperjs/static-1.10",
      "file-manager-components": "/file-manager-components/static-1.22939",
      "FileManagerImages": "/FileManagerImages/static-1.36090",
      "foundations-components-legacy": "/foundations-components-legacy/static-1.580",
      "immerable": "/immerable/static-1.3971",
      "redux-toolkit": "/redux-toolkit/static-1.7",
      "reselect": "/reselect/static-2.16",
      "ui-universal-auth": "/ui-universal-auth/static-1.8720",
      "urlinator": "/urlinator/static-1.4348",
      "video-components": "/video-components/static-1.12615",
      "video-data-lib": "/video-data-lib/static-1.34270",
      "video-embed": "/video-embed/static-1.35104",
      "redux-thunk": "/redux-thunk/static-2.43",
      "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.156",
      "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9509",
      "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9507",
      "history": "/history/static-4.47",
      "react-router-dom": "/react-router-dom/static-5.26",
      "react-dnd": "/react-dnd/static-5.6",
      "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
      "autolinker": "/autolinker/static-3.11",
      "chatspot-core": "/chatspot-core/static-1.20388",
      "chirp-fetch": "/chirp-fetch/static-1.1698",
      "ContentUtils": "/ContentUtils/static-1.67666",
      "copilot-toolkit": "/copilot-toolkit/static-1.10572",
      "sanitize": "/sanitize/static-1.4290",
      "sanitize-text": "/sanitize-text/static-1.7958",
      "content-assistance-lib": "/content-assistance-lib/static-1.7471",
      "usage-tracker": "/usage-tracker/static-1.7150",
      "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8861",
      "video-components-external": "/video-components-external/static-1.10612",
      "unified-auth-core-lib": "/unified-auth-core-lib/static-1.515",
      "content-icons-ui": "/content-icons-ui/static-1.2158",
      "social-insights-client-types": "/social-insights-client-types/static-1.21398",
      "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
      "outpost": "/outpost/static-1.4020",
      "markdown-it": "/markdown-it/static-1.6",
      "cms-field-types": "/cms-field-types/static-1.4622",
      "integrations-lib": "/integrations-lib/static-1.15461",
      "underscore": "/underscore/static-1.8",
      "magpie-lib": "/magpie-lib/static-1.5410",
      "magpie-types": "/magpie-types/static-1.4870",
      "simple-logging-lib": "/simple-logging-lib/static-1.2866",
      "superstore": "/superstore/static-1.4586",
      "ui-addon-video-player": "/ui-addon-video-player/static-1.8512",
      "ui-coaching-tips": "/ui-coaching-tips/static-1.27981",
      "navigation-messaging": "/navigation-messaging/static-1.6640",
      "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11513",
      "content-media-compositions": "/content-media-compositions/static-2.15520",
      "idb-keyval": "/idb-keyval/static-1.39",
      "media-bridge-lib": "/media-bridge-lib/static-1.18589",
      "fsm": "/fsm/static-1.3548",
      "flux-actions": "/flux-actions/static-1.310",
      "frontend-preferences-client": "/frontend-preferences-client/static-1.7740",
      "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12876",
      "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5405",
      "laboratory-lib": "/laboratory-lib/static-3.6976",
      "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7604",
      "redux-observable": "/redux-observable/static-1.11",
      "ReduxMessenger": "/ReduxMessenger/static-2.10187",
      "rxjs": "/rxjs/static-5.10",
      "ui-addon-i18n": "/ui-addon-i18n/static-1.10957",
      "ui-shepherd-react": "/ui-shepherd-react/static-3.9963",
      "reactive-lib": "/reactive-lib/static-1.541",
      "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6399",
      "hls.js": "/hls.js/static-1.34",
      "js-cookie": "/js-cookie/static-1.18",
      "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2816",
      "foundations-components-test-utils": "/foundations-components-test-utils/static-1.5038",
      "react-dlb": "/react-dlb/static-1.73",
      "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3460",
      "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6689",
      "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8609",
      "batch-promise": "/batch-promise/static-1.1367",
      "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3638",
      "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3979",
      "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3848",
      "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6594",
      "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3433",
      "multi-currency-client-types": "/multi-currency-client-types/static-1.3532",
      "persist-promise": "/persist-promise/static-1.3524"
    },
    "bundlingPackage": "conversations-embed",
    "bundlingPackageVersion": "static-1.25923",
    "project": "conversations-embed",
    "staticDomain": "//static.hsappstatic.net",
    "staticDomainPrefix": "//static.hsappstatic.net"
  }
};